import React from 'react';
import classNames from 'classnames';
import Image from '../Image/Image';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import SbImage from '../SbImage/SbImage';

export interface VideoThumbnailProps {
  video_thumbnail: StoryblokAsset;
  toggleVideo: (state: boolean) => void;
}

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  video_thumbnail,
  toggleVideo,
}) => {
  return (
    <div className={`relative group aspect-video w-full h-full`}>
      <div
        className={classNames(
          'absolute top-0 bottom-0 right-0 left-0 z-20 bg-[#07172099] transition-all duration-500 opacity-60 group-hover:opacity-70 cursor-pointer'
        )}
        onClick={() => {
          toggleVideo(true);
        }}
      ></div>
      <span
        className="h-[120px] w-[120px] bg-no-repeat transition-all duration-500 bg-button/primary-bg group-hover:bg-button/primary-bg-hover ease-in-out absolute top-0 bottom-0 right-0 left-0 m-auto z-[22] pointer-events-none"
        style={{
          WebkitMaskImage: "url('/svgs/play-btn.svg')",
          maskImage: "url('/svgs/play-btn.svg')",
        }}
      />
      <span className="h-[80px] w-[80px] bg-[white] absolute top-0 bottom-0 right-0 left-0 m-auto rounded-full z-[21] pointer-events-none" />
      {video_thumbnail && (
        <SbImage
          asset={video_thumbnail}
          options={{
            width: 768,
            sizes: { base: 600, md: 768, lg: 600 },
            objectFit: 'cover',
          }}
        />
      )}
    </div>
  );
};

export default VideoThumbnail;
